import React from "react";
import PropTypes from "prop-types";
import { parse, format } from "date-fns";

const Event = ({ events, currentState }) => {
  events.sort(function(a, b) {
    return Date.parse(a.created_at) - Date.parse(b.created_At);
  });

  const event = events.find(({ state }) => state === currentState);

  if (event !== undefined) {
    if (event.state === currentState) {
      const by = event.action.split("by")[1];
      return (
        <div>
          <small className="text-base">By: {by}</small>{"     "}
          <small className="text-muted">
            At: <i>{format(parse(event.created_at), "MM/DD/YYYY HH:mm:ss")}</i>
          </small>
        </div>
      );
    }
  } else {
    return <div />;
  }

  // console.log()
  // return <div></div>;
};

Event.propTypes = {
  event: PropTypes.object.isRequired
};

export default Event;
